import * as Styled from './ProviderForm.styled';
import { Spacer } from '../../../../helpers/genericStyles';
import { Text } from '../../../ToolkitV2/Text/Text';
import { Checkbox } from '../../../Toolkit/Inputs/Checkbox';
import { FinanceCalculator } from '../../components/FinanceCalculator/FinanceCalculator';
import { ContactFields } from '../../components/Panels/PersonalDetails/PersonalDetails';
import { StepLayout } from './StepLayout/StepLayout';
import type { QueryParameters } from '../../queries/schema/carFinance.schema';

type Props = {
  query: QueryParameters;
  introConsent: boolean;
  setIntroConsent: (value: boolean) => void;
  currentStep: number;
  totalSteps: number;
  adId: string;
  ctaLabel: string;
  onSubmit: () => void;
  dataTracking: string;
  showOutstandingFinance?: boolean;
  maxFinanceAmount?: number;
  isCashDepositRequired?: boolean;
  isSubmitting?: boolean;
};

const ShortFinanceForm = ({
  query,
  introConsent,
  setIntroConsent,
  currentStep,
  totalSteps,
  adId,
  ctaLabel,
  onSubmit,
  dataTracking,
  showOutstandingFinance = false,
  maxFinanceAmount,
  isCashDepositRequired = true,
  isSubmitting = false,
}: Props) => (
  <StepLayout
    title="Calculate monthly payments"
    currentStep={currentStep}
    totalSteps={totalSteps}
  >
    <FinanceCalculator
      dealerId={query.dealerId}
      financeHouse={query.provider}
      minimumDepositPercentage={query.minimumDepositPercentage}
      minimumDepositValue={query.minimumDepositValue}
      adId={adId}
      showOutstandingFinance={showOutstandingFinance}
      maxFinanceAmount={maxFinanceAmount}
      isCashDepositRequired={isCashDepositRequired}
    />
    <Styled.YourDetailsSection>
      <Text forwardedAs="h3" size="M16" weight="bold" color="GREY_DARKER">
        Your details
      </Text>
      <Spacer marginBottom="M16" />
      <ContactFields />
    </Styled.YourDetailsSection>
    <Styled.ConsentAndActionRow>
      <Checkbox
        name="introConsent"
        checked={introConsent}
        onChange={setIntroConsent}
        labelSize="s"
        willUseSubText={false}
        label={<>I agree to share my details with {query.dealerName}.</>}
      />
      <Styled.ContinueButton
        data-tracking={dataTracking}
        type="button"
        disabled={!introConsent || isSubmitting}
        onClick={onSubmit}
      >
        {ctaLabel}
      </Styled.ContinueButton>
    </Styled.ConsentAndActionRow>
  </StepLayout>
);

export { ShortFinanceForm };
